import { FC, useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { withPreloader } from 'shared/ui/spinner';
import { Panel } from 'shared/ui/panel';
import { useModal } from 'shared/lib/modal';
import {
	getOrder,
	OrderInfo,
	resetBookingData,
	resetOrderDetail,
	selectOrderBookingData,
	selectOrderForBooking,
	selectOrderLoader,
	selectOrdersError,
	setBookingApplicationMod,
	useOrderInfo,
} from 'entities/orders';
import { OrderDetailButtons } from '../buttons/orderDetailButtons';
import { OrderDetailProps } from '../types';
import { PersonModalCard } from 'widgets/personModalCard';
import { ModalProvider } from 'shared/ui/modal';
import { OrderDetailHeader } from './orderDetailHeader';
import { MAIN_BG_COLOR } from 'shared/consts';
import { clearLoadedTable, resetBookingDepositObject, setBookingIsEdit, setBookingIsNew } from 'entities/orders/model/ordersSlice';

export const OrderDetail: FC<OrderDetailProps> = ({
	goToBookingBtn = false,
	fetchData,
	includeButtons = true,
	maxHeightPanel = '',
  heightPanel = '',
	includePenButton = true,
	includeContactInfo = true,
	includeCloseButton = true,
	infoTitle = 'Бронирование',
	softDesign = false,
	updateOrderInPersonModal,
  minusHeight,
  hideRestore = false,
  closeWhenNotOrder = true,
  isModal = false
}) => {
	const OrderInfoWithLoader = useMemo(() => {
    return withPreloader(OrderInfo)
  }, []);
	// const OrderInfoWithLoader = withPreloader(OrderInfo);

	const { isOpen, selectedId, close, setSelectedId } = useOrderInfo();

	const order = useAppSelector(selectOrderForBooking);
	const orderBookingData = useAppSelector(selectOrderBookingData);

	const isLoading = useAppSelector(selectOrderLoader);
	const error = useAppSelector(selectOrdersError);

	const [bookingIsOpen, setBookingOpen] = useState(false);

	const dispatch = useAppDispatch();
	const { openModal } = useModal();

	useEffect(() => {
		if (isOpen && selectedId) {
			dispatch(getOrder({ id: selectedId }));
		} else {
      dispatch(resetBookingDepositObject());
      dispatch(setBookingIsEdit({isEdit: false}));
    }
	}, [isOpen, selectedId, dispatch]);

	useEffect(() => {
		if (orderBookingData.dt_start) {
			setBookingOpen(true);
		} else if (bookingIsOpen) {
			close();
			setBookingOpen(false);
		}
	}, [orderBookingData, bookingIsOpen, close]);

	const closeDetail = () => {
		close();
		setSelectedId(0);
		dispatch(resetOrderDetail());
		dispatch(resetBookingData());
    dispatch(clearLoadedTable());
	};

	const editBooking = async () => {
		if (order) {
      await dispatch(resetBookingData())
      dispatch(setBookingIsNew({isNew: false}));
      dispatch(setBookingIsEdit({isEdit: true}));
			if (!order.appointment) {
				await dispatch(setBookingApplicationMod({ isWork: true }));
			} else {
				await dispatch(setBookingApplicationMod({ isWork: false }));
			}

			openModal();
		}
	};

	useEffect(() => {
		if (!order&&closeWhenNotOrder) {
			close?.();
		}
	}, [order, close, closeWhenNotOrder]);

	return (
		<Panel
			isOpen={isOpen}
			mediaHeight={true}
			maxHeight={maxHeightPanel}
			height={heightPanel}
			includePadding={false}
			background={softDesign ? MAIN_BG_COLOR : undefined}
			roundedBorders={softDesign}
      minusHeight={minusHeight}
		>
			{!isLoading && order && (
				<OrderDetailHeader
					includeCloseButton={includeCloseButton}
					includePenButton={includePenButton}
					open={editBooking}
					close={closeDetail}
					order={order}
					roundedBorders={softDesign}
				/>
			)}

			<ModalProvider>
				<PersonModalCard
          onBooking={() => null}
					showOrderEdit={false}
					updateOrder={updateOrderInPersonModal}
				/>
				<OrderInfoWithLoader
					order={order}
					includeContactInfo={includeContactInfo}
					title={infoTitle}
					isLoading={isLoading}
					error={error}
          isModal={isModal}
				/>
			</ModalProvider>

			{!isLoading && order && includeButtons && (
				<OrderDetailButtons
					order={order}
					goToBookingBtn={goToBookingBtn}
					fetchData={fetchData}
          hideRestore={hideRestore}
				/>
			)}
		</Panel>
	);
};
